/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaymentMethod } from './PaymentMethod';
import type { User } from './User';
export type SalesOrderPayment = {
  /**
   * Unique payment identifier
   */
  id: number;
  /**
   * Payment amount
   */
  paymentAmount: number;
  /**
   * Payment method (legacy - use paymentMethodEntity)
   */
  paymentMethod?: string;
  /**
   * Payment method entity
   */
  paymentMethodEntity?: PaymentMethod;
  /**
   * Payment date
   */
  paymentDate: string;
  /**
   * Due date for scheduled payments
   */
  dueDate?: string;
  /**
   * Installment number for installments
   */
  installmentNumber?: number;
  /**
   * Total installments
   */
  installmentTotal?: number;
  /**
   * Payment status
   */
  status: SalesOrderPayment.status;
  /**
   * Payment type
   */
  paymentType: SalesOrderPayment.paymentType;
  /**
   * Item reference description
   */
  itemReference?: string;
  /**
   * Bank reference number
   */
  bankReference?: string;
  /**
   * QR transaction ID
   */
  qrTransactionId?: string;
  /**
   * Change given in cash transactions
   */
  changeGiven?: number;
  /**
   * Payment notes
   */
  paymentNotes?: string;
  /**
   * User who processed the payment
   */
  processedBy: User;
  /**
   * Creation timestamp
   */
  createdAt: string;
};
export namespace SalesOrderPayment {
  /**
   * Payment status
   */
  export enum status {
    COMPLETED = 'COMPLETED',
    PENDING = 'PENDING',
    SCHEDULED = 'SCHEDULED',
    FAILED = 'FAILED',
    CANCELLED = 'CANCELLED',
    REFUNDED = 'REFUNDED',
  }
  /**
   * Payment type
   */
  export enum paymentType {
    ITEM = 'ITEM',
    ORDER = 'ORDER',
  }
}
